import React, {Component} from "react"
import {injectIntl} from "@irati/utils/lang"
import id from "@irati/utils/id"
import {Banner} from "@irati/ui/src/Layout"
import domain from "@irati/utils/env/domain"
import {getUserAccountCookie, UserAccountForCookie} from "@irati/utils/cookies/userAccountCookie"
import DefaultLogin from "./DefaultLogin"
import GlobalLogin from "./GlobalLogin"
import AccountLogin from "./AccountLogin"

interface Props {}

interface State {
  currentView?: string
  userAccounts?: UserAccountForCookie[]
}

class Login extends Component<Props, State> {
  state = {
    currentView: undefined,
    userAccounts: undefined
  }

  componentDidMount() {
    const userAccounts: UserAccountForCookie[] = getUserAccountCookie()
    const currentView = domain.isGlobal() ? "global" : "default"

    this.setState({currentView, userAccounts})
  }

  render() {
    /**  containers should force to init the idNamespace */
    const idNamespace = id("login", this.props, {force: true})
    const {currentView, userAccounts} = this.state
    const userHasKnownAccounts = userAccounts?.length > 0

    return (
      <div id={id("container", idNamespace)}>
        <Banner id={id("banner", idNamespace)} />
        {userHasKnownAccounts && currentView === "global" && <AccountLogin id={idNamespace} userAccounts={userAccounts} {...this.props} />}
        {!userHasKnownAccounts && currentView === "global" && <GlobalLogin id={idNamespace} {...this.props} />}
        {currentView === "default" && <DefaultLogin id={idNamespace} {...this.props} />}
      </div>
    )
  }
}

export const LoginUnconnected = Login

export default injectIntl(Login)
